import { z } from 'zod';

/**
 * Shared pieces of the contracts. The field groups are plain objects spread into `z.object`, so
 * each schema keeps its fields in the same order and its inferred type stays the same.
 */

/** Query paging: `page` from 1, `pageSize` 1–100; each list keeps its own default size. */
export const pageQuery = (defaultPageSize: 25 | 50) => ({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(defaultPageSize),
});

/** Paging fields of a list response. */
export const pageFields = {
  total: z.number().int(),
  page: z.number().int(),
  pageSize: z.number().int(),
};

/** Product and variant names of a line (either language may be missing). */
export const itemNames = {
  nameEn: z.string().nullable(),
  nameAr: z.string().nullable(),
  variantNameEn: z.string().nullable(),
  variantNameAr: z.string().nullable(),
};

/** Optional inclusive `from` / `to` calendar days YYYY-MM-DD (2026-13-45 is refused). */
export const dateRangeQuery = {
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
};

/** `?branchId=`: one branch, or every branch the actor may see when absent. */
export const branchIdQuerySchema = z.object({ branchId: z.uuid().optional() });

/** `?branch=` of the online-store routes: absent means null (no branch chosen). */
export const storeBranchQuerySchema = z.object({
  branch: z
    .uuid()
    .optional()
    .transform((v) => v ?? null),
});

/** `?receipt=`: a receipt number typed or scanned at the till. */
export const receiptLookupQuerySchema = z.object({ receipt: z.string().trim().min(1).max(40) });
